<template>


  <b-row>
    <b-col md="12">
      <b-card 
        no-body 
        :class="{ open: visibleBody }" 
      >
        <b-card-header 
          style="background-color: #0080C9; color: white; font:45px; padding:1rem;  "
          :class="{ collapsed: !visibleBody }" 
          data-toggle="collapse"
          @click="() => visibleBody = !visibleBody" 
        >
          <span class="lead collapse-title"><strong>ENCUESTA</strong></span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>
        <b-collapse 
          v-model="visibleBody" 
          role="tabpanel"
        >
          <b-card-body style="padding: 1px">
            
            <div class="col-md-12">
              <b-card-code class="mt-2 principal">
                <b-row>
                  
                  <b-col>
                
                    <b-button  
                      v-if="!mostrarBotonCalificacion && mostrarbotones" 
                      class="ml-4" 
                      @click="EncuestaPadNumerico"
                    >
                      Encuesta Pad Numérico
                    </b-button>
                
                  </b-col>
                  <b-col>
                    <b-button 
                      v-if="encuestarealizada" 
                      size= "lg" 
                      variant="success" 
                      disabled
                    >
                      Encuesta Realizada
                      <i class="fas fa-check"></i>
                    </b-button>
                  </b-col>
                
                  <b-col>
                    <b-form-group label-for="encuestacita">
                      <BButton 
                        v-if="mostrarBotonCalificacion" 
                        @click="fetchEncuestaAtencion" 
                        variant="info"
                      > 
                        Obtener Calificacion 
                      </BButton>
                    </b-form-group>
                  </b-col>
                </b-row>
                  
              </b-card-code>

              <b-modal 
                id="modal-encuesta" 
                title="Encuesta" 
                ok-title="Guardar"
                @ok="guardarEncuesta" 
                cancel-title="Cancelar" 
                size="md"
              >
                <b-card>
                  <h4>Ingrese una calificacion del 1 - 4:</h4>
                  <b-form-input 
                    class="mt-2" 
                    autofocus size="md" 
                    :type="inputType" 
                    v-model="satisfaccion" 
                    @keydown="validateKey"
                  />
                
                </b-card>
              </b-modal>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row> 
  


  
 
</template>

<script>
import BCardCode from "@core/components/b-card-code";
import { BButton, BCard, BCol, BFormInput, BModal, BRow, BFormGroup } from "bootstrap-vue";
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import { v4 as uuidv4 } from "uuid";


export default {
  props: ["tokenaleatorio"],

  components: {
    BFormGroup,
    BButton,
    BModal,
    BCard,
    BFormInput,
    BRow,
    BCol,
    BCardCode,
  },
  data() {
    return {
      visibleBody: false,
      inputType : "number",
      satisfaccion : null,
      codigoQR: "",
      tokenencuesta: "",
      encuesta: "",
      mostrarBotonCalificacion: false,
      tokenenc: null,
      mostrarbotones: true,
      encuestarealizada: false,
    };
  },
  watch : {
    satisfaccion: {
      deep : true,
      handler(){
        this.inputType = 'password';
      },
    }
  },

  methods: {
    validateKey(event) {
      const validKeys = ['1', '2', '3', '4'];
      const controlKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];

      if (
        !validKeys.includes(event.key) 
        && !controlKeys.includes(event.key)    
      ) {
        event.preventDefault();  
      }

      if (this.satisfaccion >= 1 && validKeys.includes(event.key)) {
        event.preventDefault();  
      }
    },


    async guardarEncuesta() {
      
      const query = `
        mutation generarEncuestaAtencion(
          $calificacion: String!, 
          $observaciones: String!, 
          $tokenaleatorio: String!
        ) {
          crearEncuestaAM(
            encuestaData: {
              calificacion: $calificacion, 
              observaciones: $observaciones, 
              tokenaleatorio: $tokenaleatorio
            }
          ) {
            message
            status
            encuesta {
              token
              calificacion
              observaciones
            }
          }
        }
      `;
        
      const tokenn = uuidv4();
      this.tokenenc = tokenn;

      const variables = {
        calificacion: this.satisfaccion.toString(),
        observaciones: "",
        tokenaleatorio: this.tokenenc,
      };

      try {
        const response = await axios.post(rutas.axios + "api", { query, variables });


        if (response.data.data.crearEncuestaAM.status === "success") {
          const dataEncuesta = response.data.data.crearEncuestaAM.encuesta

          await this.$swal({
            icon: "success",
            title: "Éxito",
            text: "La encuesta se creó correctamente.",
          });

          this.$store.commit("setSubidoEncuesta", dataEncuesta)
          this.mostrarbotones = false;
          localStorage.removeItem('enc')
          this.encuestarealizada = true;
          localStorage.setItem('enc', this.encuestarealizada)
         
        } else {
          this.$swal({
            title: "Error",
            text: response.data.data.crearEncuestaAM.message,
            icon: "error",
            confirmButtonColor: "#089599",
          });
        }
      } catch (error) {
        await this.$swal({
          icon: "error",
          title: "Error",
          text: error.message || "Hubo un problema al crear la imagen.",
        });
      }
    },

    async goToEncuesta() {
      try {
        const tokenn = uuidv4();
        this.tokenencuesta = tokenn;
        this.$emit('token-enviado', tokenn);

        const query = `
          mutation generarEncuestaAtencion(
            $calificacion: String!, 
            $observaciones: String!, 
            $tokenaleatorio: String!
          ) {
            crearEncuestaAM(
              encuestaData: {
                calificacion: $calificacion, 
                observaciones: $observaciones, 
                tokenaleatorio: $tokenaleatorio
              }
            ) {
              message
              status
            }
          }
        `;

        const variables = {
          calificacion: 'Aun no ingresa calificacion',
          observaciones: 'Aun no ingresa observacion',
          tokenaleatorio: this.tokenencuesta,
        };

        const response = await axios.post(rutas.axios + "api", { query, variables });

        if (response.data.data.crearEncuestaAM) {
          this.mostrarBotonCalificacion = true;

          const ruta = this.$router.resolve({
            name: "codigo_qr",
            params: { token: this.tokenencuesta },
          });

          const url = ruta.href;
          window.open(url, "_blank");
        } else {
          console.error("La creación de la encuesta no fue exitosa.");
        }

      } catch (error) {
        console.error("Error al realizar la solicitud:", error);
      }
    },


    EncuestaPadNumerico() {
      this.padnumerico = true;

      if(!this.calificacion){
        this.inputType = 'number'
      }
      
      this.$bvModal.show('modal-encuesta');
    },


    async fetchEncuestaAtencion() {
      const query = `
        query obtenerEncuestaPorTokenAleatorio($tokenaleatorio: String!) {
          allEncuestaAtencion(tokenaleatorio: $tokenaleatorio) {
            calificacion
            estado
            fechaCreacion
            id
            observaciones
            token
            tokenaleatorio
            ultimoCambio
          }
        }
      `;
      const tokenaleatorio = this.tokenencuesta;

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: { tokenaleatorio: tokenaleatorio },
        });

        if (
          response.data.data.allEncuestaAtencion 
          && response.data.data.allEncuestaAtencion.length > 0 
          && response.data.data.allEncuestaAtencion[0].calificacion
        ) {
          await this.$swal({
            icon: "success",
            title: "Éxito",
            text: "El paciente ingresó la calificación. Puede continuar.",
          });
          this.encuesta = response.data.data.allEncuestaAtencion[0].calificacion;
        } else {
          await this.$swal({
            icon: "warning",
            title: "Vuelva a intentarlo",
            text: "El paciente aún no ha ingresado la calificación.",
          });
        }
      } catch (error) {
        console.error("An error occurred while fetching the options:", error);
      }
    },
  },
};
</script>

<style>
.principal .card-header {
  display: none !important;
}

.principal .card-body {
  padding-bottom: 0 !important;
}
</style>

<style scoped src="@/assets/css/dropfile.css"></style>
